import { UseFormReturn } from 'react-hook-form';
import { useCallback } from 'react';
import { BoloPanelFormType, BoloPanelView } from '@mark43/cad-api';
import { BoloPanelMetadataStore } from '../state/bolo-panel-metadata-store';

interface UseRefreshBoloDataProps {
    boloForm: UseFormReturn<BoloPanelFormType>;
    boloMetadataStore?: BoloPanelMetadataStore;
}

export const useRefreshBoloPanel = (deps: UseRefreshBoloDataProps) => {
    const { boloForm, boloMetadataStore } = deps;
    return useCallback(
        (boloPanelView: BoloPanelView) => {
            boloForm.reset(boloPanelView.boloPanelForm as BoloPanelFormType);
            boloMetadataStore?.setBoloPanelMetadata(boloPanelView.boloPanelMetadata);
        },
        [boloForm, boloMetadataStore]
    );
};
